var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import settingsDictionary from '../../../strings/settingsDictionary';
import { CategoryIconWrapper, CategoryTitle, CategoryTitleWrapper, Icon } from './subcomponents';
var alertsCategoriesIcons = settingsDictionary.alertsCategoriesIcons;
var AlertCategoryTitle = function (_a) {
    var categoryKey = _a.categoryKey;
    var t = useTranslation().t;
    var categoryTitle = t("alertsCategoriesTitles.".concat(categoryKey))
        ? t("alertsCategoriesTitles.".concat(categoryKey))
        : "Undefined Category Title for ".concat(categoryKey);
    return (_jsxs(CategoryTitleWrapper, __assign({ "data-test": "CategoryTitleWrapper" }, { children: [_jsx(CategoryIconWrapper, __assign({ "data-test": "CategoryIconWrapper" }, { children: _jsx(Icon, { icon: alertsCategoriesIcons[categoryKey], size: "lg" }) })), _jsx(CategoryTitle, __assign({ "data-test": "CategoryTitle" }, { children: categoryTitle }))] })));
};
export default AlertCategoryTitle;
